document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("[data-component=customer-header]");
  if (!header) return;

  const logoutLink = document.querySelector("#customer_logout_link");
  if (logoutLink) {
    logoutLink.addEventListener("click", function () {
      localStorage.removeItem("ichigo_admin_user");
      localStorage.removeItem("ichigo_admin_token");
    });
  }
});